// TODO QS-10687: Replace with the official third-party logo when available.
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeK15tScrollSitesIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-k15t-scroll-sites-dev" */ './utils').then(
			(m) => m.ForgeK15tScrollSitesIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-k15t-scroll-sites-dev/icon' },
);

const LazyForgeK15tScrollSitesSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-k15t-scroll-sites-dev-search-result" */ './utils').then(
			(m) => m.ForgeK15tScrollSitesSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-k15t-scroll-sites-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeK15tScrollSitesIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeK15tScrollSitesIconComponent />
	</Suspense>
);

export const ForgeK15tScrollSitesSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeK15tScrollSitesSearchResultIconComponent />
	</Suspense>
);
